
export default {
  name: "SectionCheckboxImages",

  props: {
    form: {
      type: Object,
      default: () => {
        return {}
      }
    },
    section: {
      type: Object,
      default: () => {
        return {}
      }
    },
    indexForm: {
      type: Number,
      default: 0
    }
  },

  computed: {
    items: function () {
      return this.section?.items || []
    }
  },

  methods: {
    clickCard: function (index) {
      let form = {...this.form};

      let value = [];
      if (this.section?.multiple) {
        value = [...(form[this.indexForm] || [])]
      }
      if (value.includes(index)) {
        value.splice(value.indexOf(index), 1);
      } else {
        value.push(index);
      }

      form[this.indexForm] = value;
      this.$emit('change', form);
      if (!this.section?.multiple) {
        this.$emit('nextStage');
      }
    },

    _isActive: function (itemIndex) {
      return Boolean((this.form?.[this.indexForm] || []).includes(itemIndex))
    }
  }
}
